import { render, staticRenderFns } from "./TestModal.vue?vue&type=template&id=369855ae"
import script from "./TestModal.vue?vue&type=script&lang=js"
export * from "./TestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports